import React, { useRef, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  IconButton,
  FormControlLabel,
  Checkbox,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { CustomButton } from "./CustomButton";
import { useTranslation } from "react-i18next";
import logoAn from "../assets/LogoAn.png";
import AppBar from "@mui/material/AppBar";
import Logo from "../assets/Logo.png";
import { styles } from "../theme/styles";
import Swal from "sweetalert2";
import SignatureCanvas from "react-signature-canvas";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import { connect } from "react-redux";
import { Creators } from "../store/ducks/users";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import { DatosCompradorContext } from "../context/Context";
import Cookies from "js-cookie";
import { decodedData, encodeData } from "../helpers/encode";

const PdfView = (props) => {
  const { userData } = props;
  const {
    correoCompradorContext,
    setCorreoCompradorContext,
    tiendaAsociadaContext,
    setTiendaAsociadaContext,
    rolContext,
    setRolContext,
    idGeneradoContext,
    setIdGeneradoContext,
    idbuscadoContext,
    setIdbuscadoContext,
    resetDatosFolio,
    skuContext,
    setSkucontext,
  } = useContext(DatosCompradorContext);
  const auxcomp = correoCompradorContext;
  const title1 =
    "Por favor verifica los datos antes de generar la nota de venta";
  const title2 = "Nota de venta finalizada";
  const [nombreArchivoPDF, setNombreArchivoPDF] = useState("");
  const [nombreVendedor, setNombreVendedor] = useState("");
  const [mostrarMensaje, setMostrarMensaje] = useState(true);
  const [idVendedor, setIDvendedor] = useState("");
  const [aux1, setAux1] = useState(false);
  const [aux2, setAux2] = useState();
  const [finishAux, setFinishAux] = useState(true);
  const [auxiliar, setAuxiliar] = useState(false);
  const auxURL = process.env.REACT_APP_BACK_APIVENTAANIMALES;
  const auxCorreoComprador = correoCompradorContext;
  const [pageNumber, setPageNumber] = useState(1);
  const [imageData, setImageData] = useState("");
  const [firmaCompradorData, setFirmaCompradorData] = useState();
  const [firmaVendedorData, setFirmaVendedorData] = useState();
  const [isActive, setIsActive] = useState(false);
  const [isChecked, setIsChecked] = useState(false); //false
  const [isSigned1, setIsSigned1] = useState(false); //false
  const [isSigned2, setIsSigned2] = useState(false); //false
  const [firmaSeleccionada, setFirmaSeleccionada] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const [reloadIframe, setReloadIframe] = useState(false);
  const [pdfLink, setPdfLink] = useState("");
  const targetRef = useRef();
  const [loadingsppiner, setLoadingSpinner] = useState(false);
  const [folio, setFolio] = useState(
    idGeneradoContext ? idGeneradoContext : decodedData("FOLIO")
  );
  const navigate = useNavigate();
  const sigCanvas = useRef(null);
  const { t } = useTranslation();

  const getPdf = async () => {
    const r1 = await axios.post(
      `${auxURL}/imagenes/existePdfFinal`,
      {
        idG: folio,
        idVendedor: userData.idNumber,
      },
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
          apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
          "Content-Type": "application/json",
        },
      }
    );
    setAux2(r1.data.msg);
  };

  useEffect(() => {
    setIDvendedor(userData.idNumber);
    setNombreArchivoPDF(folio);
    if (folio && userData.idNumber) {
      getPdf();
    }
  }, []);

  const handleReloadIframe = () => {
    setReloadIframe(!reloadIframe); // cambiar el estado de reloadIframe para forzar la re-renderización del iframe
    // setLoadingSpinner(false)
  };

  useEffect(() => {
    if (folio && userData?.idNumber) {
      setPdfLink(
        `${auxURL}/imagenes/obtenerPDF2/${folio}/${userData.idNumber}` //checar si meter idGeneradoContext a localStorage
      );
    }
  }, [reloadIframe, userData?.idNumber]);

  function adjustZoom() {
    const windowWidth = window.innerWidth;
    let zoom;

    if (windowWidth > 768) {
      zoom = 100; // Zoom para pantallas pequeñas
    } else if (windowWidth > 400 && windowWidth > 768) {
      zoom = 70; // Zoom para pantallas medianas
    } else if (windowWidth > 400) {
      zoom = 40; // Zoom para pantallas grandes
    }
  }
  adjustZoom();

  const navegar = (url) => {
    Cookies.remove("FOLIO");
    Cookies.remove("TERMINOS");
    Cookies.remove("FINALIZAR1");
    Cookies.remove("nombreVendedor");
    navigate(url);
  };

  const handleClearCanvas = () => {
    sigCanvas.current.clear();
  };

  const saveSignature = async (signature, id) => {
    setIsActive(false);
    setImageData(signature);
    //despues borrar esto, solo es prueba para asignar en true la firma que ya se registró
    if (firmaSeleccionada == 1) {
      setIsSigned1(true);
      setFirmaVendedorData(signature);
      const enviarFirmaVendedor = await axios.post(
        `${auxURL}/imagenes/guardarImagen`,
        {
          imageDataUri: signature,
          idVendedor: userData.idNumber,
          tipo: "Vendedor",
          idGenerado: folio,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        }
      );
    } else if (firmaSeleccionada == 2) {
      setIsSigned2(true);
      setFirmaCompradorData(signature);
      const enviarFirmaComprador = await axios.post(
        `${auxURL}/imagenes/guardarImagen`,
        {
          imageDataUri: signature,
          idVendedor: userData.idNumber,
          tipo: "Comprador",
          idGenerado: folio,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
            apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
            "Content-Type": "application/json",
          },
        }
      );
    }
  };

  const isValidName = (name) => {
    const twoWordsRegex = /^\s*\S+\s+\S+/;
    if (!twoWordsRegex.test(name)) {
      return false;
    } else {
      return true;
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    encodeData("TERMINOS", "true");
    if (isChecked) {
    } else {
    }
  };

  const openVentanaEmergente = (opcion) => {
    if (opcion === "1") {
      setFirmaSeleccionada(1);
    } else if (opcion === "2") {
      setFirmaSeleccionada(2);
    }
    setIsActive(true);
    handleClearCanvas();
  };

  const closeVentanaEmergente = () => {
    setIsActive(false);
    handleClearCanvas();
    setFirmaSeleccionada(0);
  };

  const handleFinalizado = async () => {
    setMostrarMensaje(false);
    setLoadingSpinner(true);
    if (!isSigned1 || !isSigned2) {
      Swal.fire({
        title: "Favor de registrar las dos firmas.",
        icon: "warning",
        iconColor: "red",
        confirmButtonColor: "#00205B",
      });
      return;
    }
    setIsFinished(true);
    encodeData("FINALIZAR1", "true");
    if (firmaCompradorData !== "" && firmaVendedorData !== "") {
      try {
        const anadirImagenes = await axios.post(
          //SE agregan las imagenres al servidor
          `${auxURL}/ventas/agregarImagenes`,
          {
            idVendedor: userData.idNumber,
            idG: folio,
            nombreVendedor: decodedData("nombreVendedor"),
          },
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
              apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (anadirImagenes.status == 200) {
          //cambiar a convertir pdf en convert2
          const bridgeToback = await axios.post(
            `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/imagenes/getPdf2Bridge`,
            {
              idVendedor: `${userData.idNumber}`,
              idG: `${folio}`,
            },
            {
              headers: {
                Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                apikey: `${process.env.REACT_APP_APIKEY}`,
                "Content-Type": "application/json",
              },
            }
          );

          handleReloadIframe();
        }
        //ejecutar la eliminacion de archivos reciduales
        setLoadingSpinner(false);
        setFinishAux(false);
        setAuxiliar(!auxiliar);
        //cambio de estatus en contrato
        await axios.post(
          `${auxURL}/folios/actualizarEstatusFolio`,
          {
            folio: folio,
          },
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
              apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
              "Content-Type": "application/json",
            },
          }
        );
      } catch (error) {}
    }
  };

  return (
    <>
      <div style={{ overflow: "hidden", ...styles.backgroundLog }}>
        <Grid style={styles.divPdf}>
          <div>
            <IconButton style={styles.btnBack} onClick={() => navegar("/home")}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-arrow-back"
                width="36"
                height="36"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="#00205b"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1" />
              </svg>
            </IconButton>

            {pdfLink !== "" && (
              <>
                {!auxiliar && mostrarMensaje ? (
                  <h1
                    style={{
                      fontSize: "30px",
                      marginTop: "-50px",
                      color: "#00205B",
                      marginBottom: "5px",
                    }}>
                    Favor de verificar los datos
                  </h1>
                ) : (
                  !loadingsppiner && (
                    <h1
                      style={{
                        fontSize: "20px",
                        marginTop: "-50px",
                        color: "#00205B",
                        marginBottom: "5px",
                      }}>
                      Documento Finalizado
                    </h1>
                  )
                )}
              </>
            )}
          </div>

          {pdfLink !== "" ? (
            <>
              {!loadingsppiner ? (
                <iframe
                  style={styles.pdfViewer3}
                  src={pdfLink}
                  frameBorder="0"
                  scrolling="no"
                  key={reloadIframe}
                />
              ) : (
                <div
                  style={{
                    ...styles.pdfViewer3,
                  }}>
                  <ClipLoader size={80} />
                  <h3>Generando nota de venta...</h3>
                </div>
              )}
            </>
          ) : (
            <>
              {!userData.idNumber ? (
                <div
                  style={{
                    ...styles.pdfViewer3,
                  }}>
                  <ClipLoader size={80} />
                </div>
              ) : (
                <>
                  <h1
                    style={{
                      fontSize: "30px",
                      marginTop: "-50px",
                      color: "#00205B",
                      marginBottom: "5px",
                    }}>
                    No se pudo cargar el PDF.
                  </h1>
                </>
              )}
            </>
          )}

          <div ref={targetRef}></div>

          {!isChecked && decodedData("TERMINOS") === "false" && (
            <FormControlLabel
              style={{ marginTop: "5px" }}
              label="Confirmo que los datos en el documento son correctos."
              control={
                <Checkbox
                  checked={isChecked}
                  onClick={handleCheckboxChange}
                  name="Si"
                />
              }
            />
          )}

          {!isFinished &&
            decodedData("TERMINOS") === "true" &&
            decodedData("FINALIZAR1") === "false" && (
              <div style={styles.containerFirma}>
                <CustomButton
                  style={styles.btnPdf}
                  disabled={!isSigned1 ? false : true}
                  onClick={() => openVentanaEmergente("1")}>
                  FIRMA VENDEDOR
                </CustomButton>
                <CustomButton
                  style={styles.btnPdf}
                  disabled={!isSigned2 ? false : true}
                  onClick={() => openVentanaEmergente("2")}>
                  FIRMA COMPRADOR
                </CustomButton>
                <CustomButton
                  // disabled={isSigned1 || isSigned2 ? false : true}
                  disabled={isSigned1 && isSigned2 ? false : true}
                  style={styles.btnPdf}
                  onClick={handleFinalizado}>
                  FINALIZAR
                </CustomButton>
              </div>
            )}

          {/*Validar que el cliente tenga un correo inscrito validar variable*/}
          {correoCompradorContext !== "" &&
            !loadingsppiner &&
            !mostrarMensaje && (
              <CustomButton
                style={styles.btnPdf21}
                onClick={async (e) => {
                  e.preventDefault();
                  try {
                    const respCorreo = await axios.post(
                      `${auxURL}/imagenes/enviarPDFporCorreo`,
                      {
                        correoComprador: correoCompradorContext,
                        idG: folio,
                        idVendedor: userData.idNumber,
                        sku: skuContext,
                      },
                      {
                        headers: {
                          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                          apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
                          "Content-Type": "application/json",
                        },
                      }
                    );
                    //ELIMINAR ARCHIVOS TEMPORALES
                    Swal.fire({
                      title: "Correo enviado correctamente.",
                      text: `a ${correoCompradorContext}`,
                      icon: "success",
                      confirmButtonText: "Regresar",
                      confirmButtonColor: "#00205B",
                      iconColor: "green",
                      allowOutsideClick: false,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        const elminarTemp = axios.post(
                          `${auxURL}/imagenes/eliminarArchivosRec`,
                          {
                            idG: folio,
                            idVendedor: userData.idNumber,
                          },
                          {
                            headers: {
                              Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                              apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
                              "Content-Type": "application/json",
                            },
                          }
                        );
                        resetDatosFolio();
                        navigate("/home");
                      }
                    });
                  } catch (error) {
                    Swal.fire({
                      title: "Error al enviar correo",
                      icon: error,
                      confirmButtonText: "Regresar",
                      confirmButtonColor: "#00205B",
                      iconColor: "red",
                    });
                    navigate("/home");
                    resetDatosFolio();
                  }
                }}>
                ENVIAR POR CORREO
              </CustomButton>
            )}

          {correoCompradorContext == "" &&
            !loadingsppiner &&
            decodedData("FINALIZAR1") === "true" && (
              <CustomButton
                style={styles.btnPdf21}
                onClick={async (e) => {
                  e.preventDefault();
                  try {
                    //ELIMINAR ARCHIVOS TEMPORALES
                    Swal.fire({
                      title: "Nota de venta creada exitosamente.",
                      icon: "success",
                      confirmButtonText: "Regresar",
                      confirmButtonColor: "#00205B",
                      iconColor: "green",
                      allowOutsideClick: false,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        const elminarTemp = axios.post(
                          `${auxURL}/imagenes/eliminarArchivosRec`,
                          {
                            idG: folio,
                            idVendedor: userData.idNumber,
                          },
                          {
                            headers: {
                              Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
                              apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
                              "Content-Type": "application/json",
                            },
                          }
                        );
                        resetDatosFolio();
                        Cookies.remove("FOLIO");
                        Cookies.remove("TERMINOS");
                        Cookies.remove("FINALIZAR1");
                        Cookies.remove("nombreVendedor");
                        navigate("/home");
                      }
                    });
                  } catch (error) {
                    Swal.fire({
                      title: "Error al enviar correo",
                      icon: error,
                      confirmButtonText: "Regresar",
                      confirmButtonColor: "#00205B",
                      iconColor: "red",
                    });
                    navigate("/home");
                    resetDatosFolio();
                  }
                }}>
                FINALIZAR
              </CustomButton>
            )}
        </Grid>
      </div>

      <div
        className={`overlay ${isActive ? "active" : "inactive"}`}
        id="overlay">
        <div className="popup-abc" id="popup">
          <div className="btn-cerrar-popup">
            <span onClick={closeVentanaEmergente} title="Cerrar Ventana">
              x
            </span>
          </div>
          {firmaSeleccionada == 1 && (
            <>
              <p>Nombre del Vendedor</p>
              <TextField
                size="small"
                value={nombreVendedor}
                onChange={(e) => {
                  e.preventDefault();
                  let inputValue = e.target.value;
                  inputValue = inputValue
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase());
                  setNombreVendedor(inputValue);
                }}
              />
            </>
          )}

          <div className="sign-component">
            <p
              style={{
                marginTop: "10px",
              }}>
              Ingrese su firma en el siguiente recuadro:
            </p>
            <SignatureCanvas
              ref={sigCanvas}
              penColor="#00205B"
              canvasProps={{
                style: styles.divCanvas,
              }}></SignatureCanvas>
            <Button style={styles.btnFirma} onClick={handleClearCanvas}>
              REPETIR FIRMA
            </Button>
          </div>
          <div className="pz-center">
            <CustomButton
              style={styles.btnPdf}
              onClick={(e) => {
                e.preventDefault();
                var aux =
                  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC";

                if (
                  sigCanvas.current.getTrimmedCanvas().toDataURL("image/png") ==
                  aux
                ) {
                  Swal.fire({
                    title: "Favor de ingresar una firma",
                    icon: "warning",
                    iconColor: "red",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#00205B",
                  });
                  return;
                } else if (firmaSeleccionada == 1 && nombreVendedor === "") {
                  Swal.fire({
                    title: "Ingrese el nombre del vendedor",
                    icon: "warning",
                    iconColor: "red",
                    confirmButtonColor: "#00205B",
                  });
                  return;
                } else if (
                  firmaSeleccionada == 1 &&
                  !isValidName(nombreVendedor)
                ) {
                  Swal.fire({
                    title: "Error",
                    text: "El nombre del vendedor debe contener nombre y apellido",
                    icon: "error",
                    iconColor: "red",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: "#00205B",
                  });
                  return;
                } else {
                  if (firmaSeleccionada == 1) {
                    encodeData("nombreVendedor", nombreVendedor);
                  }
                  saveSignature(
                    sigCanvas.current.getTrimmedCanvas().toDataURL("image/png")
                  );
                }
              }}>
              GUARDAR
            </CustomButton>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    menu: state.users.menu,
    userData: state.users.data,
    message: state.config.message,
    redirectToPasswordScreen: state.users.redirectToPasswordScreen,
  };
};
const creators = {
  logout: Creators.logout,
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, creators)(PdfView);
